import React from "react";
import { Route, Redirect } from "react-router-dom";
import AdminLayout from "layouts/AdminLayout";
import _authService from "modules/AuthService.js";
import NetworkDetector from "../HOC/NetworkDetector";

const AdminRoute = ({ component: Component, layout: Layout, role: role, menuId: menuId, ...rest }) => (
  <Route key={Math.floor((Math.random() * 9999999) + 1)} {...rest} render={props => (
    //Also check role
    _authService.isAdminAuthenticated()
      ?
      <AdminLayout componentName={menuId}>
        <Component {...props} />
      </AdminLayout>
      :
      <Redirect to={{
        pathname: '/admin/login'
      }} />
  )} />

  // <Route {...rest} render={props => (
  //     <PrivateLayout>
  //       <Component {...props} />
  //     </PrivateLayout>
  //   )} />
)

export default NetworkDetector(AdminRoute)